export default "__VITE_ASSET__7f2be096__"